import { Button, CheckboxEditor, TextEditor } from '@approvalmax/ui';
import { animated } from '@react-spring/web';
import SsoPanel from 'modules/auth/components/SsoPanel/SsoPanel';
import { font, theme } from 'modules/styles';
import SignUpProgress from 'pages/auth/components/SignUpProgress/SignUpProgress';
import styled from 'styled-components';

import SignupConsent from '../SignupConsent/SignupConsent';

export const Root = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ProgressContainer = styled(SignUpProgress)`
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
`;

export const Title = styled.div`
    ${font(24, '#384650')};
    text-align: center;
    margin-bottom: 25px;
`;

export const EmailSection = styled.div`
    text-align: center;
    font-weight: ${theme.fontWeight.bold};
    margin-bottom: 15px;
`;

export const NameSection = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
`;

export const SignUpButton = styled(Button)`
    margin-top: 15px;
`;

export const StyledSignupConsent = styled(SignupConsent)`
    margin-top: 20px;
`;

export const StyledTextEditor = styled(TextEditor)`
    padding-top: 10px;
    padding-bottom: 10px;
`;

export const PasswordTextEditor = styled(StyledTextEditor)`
    padding-right: 28px;
    color: #000000;
    font-size: 14px;
`;

export const QuestionsSection = styled.div`
    margin-top: 20px;
`;

export const PasswordEditorWrp = styled.div`
    position: relative;
`;

export const PasswordToggleButton = styled.button`
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    color: #4c8a5c;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export const PasswordValidation = styled.div`
    background-color: #f3f3f3;
    border-radius: 0 0 8px 8px;
    padding: 10px 10px 0 10px;
`;

export const PhoneSection = styled.div`
    margin-bottom: 10px;
`;

export const AnimatedBox = styled(animated.div as any)`
    overflow: hidden;
`;

export const MarketingCheckboxEditor = styled(CheckboxEditor)`
    margin-top: 30px;
`;

export const SsoDelimiter = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    ${font(12, '#6c6a6a')};
    margin-top: 50px;
    margin-bottom: 20px;

    &:before,
    &:after {
        content: '';
        flex: 1 1;
        border-bottom: 1px solid #cacccd;
        margin: auto;
    }
    &:before {
        margin-right: 10px;
    }
    &:after {
        margin-left: 10px;
    }
`;

export const StyledSsoPanel = styled(SsoPanel)`
    margin-top: 0;
`;
